import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Coding, farting and bicycles",
  "description": "",
  "published": "2008-07-27T00:00:00.000Z",
  "redirect_from": ["/blog/coding-farting-and-bicycles/swizec/89"],
  "categories": "food for thought, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Farting. Everybody does it and yet everyone is afraid of talking about it, in fact it's more taboo than any other topic even sex. You can talk about sex, murder, masochism or pretty much anything with almost anyone, you can often talk about it even on public television, often even show it, but farting, not with farting. Farting cannot even be mentioned. It's something to be ashamed of.`}</p>
    <p>{`But why is that when it feels so bloody good? In fact I'd venture to say farting can often produce a much happier feeling than sex or even orgasm can. Sometimes, when the fart is especially good, orgasm can just go hide in a corner and observe the great, big, wide, collosal smile a fart produces on my face. And when you combine it with everyone else's frown! Pure gold.`}</p>
    <p>{`Yes, farts are gold. But not as gold as accidentally coming acros a plasmoid online that just so happens to teach you how to do something so you can improve your own plasmoid, and so it is that `}<a parentName="p" {...{
        "href": "http://kde-look.org/content/show.php?content=85564"
      }}>{`Tea Cooker 0.2`}</a>{` is happily available for your steeping pleasures. It's still a very fun project to work on, infinitely more fun than php has been for a while, if for nothing else than php becoming a bit of standard procedure for me and this, this is awesome and new and I get to `}<em parentName="p">{`learn.`}</em></p>
    <p>{`But what of bicycles? How do bicycles from the title come into play around here? Well they don't really, I'd just like to mention that they're a pain to work on even though they're very simple mechanisms in comparison to what I usually work with (a bike is some tens of parts combined together, software is thousands of parts running on billions of parts machinery). Working on bicycles can suck my donkey cock in fact. Sure they're simple, but oh so very annoying and DIRTY. Ugh.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      